<template>
  <div class="el-home2">
    <el-header class="el-top-header">
      <div class="header-logoName" >
        <img src="@/images/logo2.png" alt="logo" style="height: 60px;margin-top: 10px">
      </div>
      <div class="header-system">
        <div class="userinfo">
          <el-dropdown trigger="click" @command="handleCommand">
              <span class="el-dropdown-link userinfo-inner">
                <i class="iconfont el-icon-liebiaoshitucaidan" style="font-size: 24px"></i>
              </span>
            <el-dropdown-menu slot="dropdown">
              <el-dropdown-item command="editpass">{{$t('home.editPasswd')}}</el-dropdown-item>
              <el-dropdown-item command="singOut">退出</el-dropdown-item>
            </el-dropdown-menu>
          </el-dropdown>
        </div>
      </div>
    </el-header>
      <el-table
        :data="tableData"
        style="width: 100%"
        v-loading="loading"
        :row-class-name="tableRowClassName">
        <el-table-column
          prop="license_name"
          label="客户">
        </el-table-column>
        <el-table-column
          prop="project_id"
          label="项目">
          <template slot-scope="scope">
            <span v-if="scope.row.project_id === 1">相框</span>
            <span v-if="scope.row.project_id === 21">日历机</span>
            <span v-if="scope.row.project_id === 5">IPC</span>
            <span v-if="scope.row.project_id === 9">面具</span>
          </template>
        </el-table-column>
        <el-table-column
          prop="batch_name"
          label="批次号">
        </el-table-column>

        <el-table-column
          prop="total_num"
          label="总数量">
        </el-table-column>
        <el-table-column
          prop="number"
          label="已使用数量">
          <template slot-scope="scope">
            {{scope.row.total_num-scope.row.surplus_num}}
          </template>
        </el-table-column>
        <el-table-column prop="surplus_num" label="剩余数量"></el-table-column>
        <el-table-column prop="activateNumber" label="激活数量"></el-table-column>
        <el-table-column
          prop="create_time"
          label="创建日期">
        </el-table-column>
        <el-table-column prop="id" label="操作" width="240">
          <template slot-scope="scope">
            <el-button type="text" size="mini"  @click="activationLog(scope.row)">授权记录</el-button>
            <el-button type="text" size="mini"  @click="exportSnCreateLog(scope.row)">导出授权记录</el-button>
            <el-button type="text" size="mini"  @click="exportSnUserCreateLog(scope.row)">导出绑定用户</el-button>
          </template>
        </el-table-column>
      </el-table>

    <el-dialog title="授权记录" :visible.sync="dialogActivationVisible" width="60%">
      <el-row type="flex" style="flex-wrap: wrap;flex-direction: row" justify="space-between">
        <el-col :xl="10" :lg="10" :md="10" :sm="24" :xs="24">
          <el-date-picker
            v-model="query.createTime"
            type="date"
            size="small"
            value-format="yyyy-MM-dd"
            placeholder="选择创建日期">
          </el-date-picker>
        </el-col>
        <el-col :xl="12" :lg="12" :md="12" :sm="24" :xs="24" >
          <el-input size="small" placeholder="请输入设备id" v-model.trim="query.virturlSn" class="input-with-select">
            <el-button slot="append" icon="el-icon-search" type="primary"  @click="activatedSearch()">搜索</el-button>
            <el-button slot="append" icon="el-icon-refresh-left"  @click="activatedResetBtn()">重置</el-button>
          </el-input>
        </el-col>
      </el-row>
      <el-table :data="gridData" v-loading="loading2">
        <el-table-column property="virturl_sn" label="设备ID" ></el-table-column>
        <el-table-column property="model_sn" label="机型SN" ></el-table-column>
        <el-table-column property="os_version" label="OS版本号"></el-table-column>
        <el-table-column property="id" label="授权状态">
          <template slot-scope="scope">
            <span v-if="scope.row.behavior== 1">已授权</span>
            <span v-else-if="scope.row.behavior== 2">已撤销</span>
          </template>
        </el-table-column>
        <el-table-column property="create_time" label="创建日期"></el-table-column>
      </el-table>

      <el-pagination
        @size-change="activationSizeChange"
        @current-change="activationCurrentChange"
        :current-page="query.currentPage"
        :page-sizes="[5, 10]"
        :page-size="query.pageSize"
        layout="total, sizes, prev, pager, next, jumper"
        :total="total">
      </el-pagination>

    </el-dialog>

    <el-dialog title="密钥KEY" :visible.sync="dialogVisible"  width="40%">
      <span>license_cert={{keyMsg}}</span>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="dialogVisible = false">确 定</el-button>
      </span>
    </el-dialog>

    <el-dialog title="修改密码" v-loading="editpassloading" :visible.sync="dialogFormVisible" center>
      <el-form :model="userpass" ref="userpass" :rules="rules">
        <el-form-item label="原密码" :label-width="formLabelWidth" prop="pass">
          <el-input size="small" v-model="userpass.pass" type="password" auto-complete="off" placeholder="请输入原密码"></el-input>
        </el-form-item>
        <el-form-item label="新密码" :label-width="formLabelWidth" prop="editpass">
          <el-input size="small" v-model="userpass.editpass" type="password" auto-complete="off" placeholder="请输入新密码"></el-input>
        </el-form-item>
        <el-form-item label="确认新密码" :label-width="formLabelWidth" prop="neweditpass">
          <el-input size="small" v-model="userpass.neweditpass" type="password" auto-complete="off" placeholder="请输入确认密码"></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button size="small" @click="cancelUserPass()">取 消</el-button>
        <el-button size="small" type="primary" @click="userEditpass('userpass')">确 定</el-button>
      </div>
    </el-dialog>

  </div>
</template>

<script>
import {exportFile} from "table-xlsx";
import md5 from 'md5'
const columns = [
  { title: '设备ID', dataIndex: 'virturl_sn' },
  { title: '机型', dataIndex: 'model_sn' },
  { title: 'OS版本', dataIndex: 'os_version'},
  { title: '授权状态',dataIndex: 'behaviorType'},
  { title: '授权时间',dataIndex: 'create_time'},
]
const columns2 = [
  { title: '设备ID', dataIndex: 'virturl_sn' },
  { title: 'email', dataIndex: 'email' },
  { title: '机型', dataIndex: 'model_sn' },
  { title: 'OS版本', dataIndex: 'os_version'},
  { title: '授权状态',dataIndex: 'behaviorType'},
  { title: '授权时间',dataIndex: 'create_time'},
]
export default {
  name: "virtualSnListView",
  data() {
    var validatePass = (rule, value, callback) => {
      if (value !== this.userpass.editpass) {
        return callback(new Error('两次输入密码不一致'))
      } else {
        return callback()
      }
    }
    return {
      tableData: null,
      dialogActivationVisible: false,
      gridData: null,
      total: null,
      query: {
        currentPage: 1,
        pageSize: 5,
        batchSn: null,
        virturlSn: null,
        createTime: null
      },
      dialogVisible: false,
      keyMsg: null,
      loading: false,
      loading2: false,
      dialogFormVisible: false,
      rules: {
        pass: [
          { required: true, message: '请输入原密码', trigger: 'blur' },
          { min: 6, message: '请输入密码长度6位数以上字符', trigger: 'blur' }
        ],
        editpass: [
          { required: true, message: '请输入新密码', trigger: 'blur' },
          { min: 6, message: '请输入密码长度6位数以上字符', trigger: 'blur' }
        ],
        neweditpass: [
          { required: true, message: '请输入确认密码', trigger: 'blur' },
          { min: 6, message: '请输入密码长度6位数以上字符', trigger: 'blur' },
          { validator: validatePass, trigger: 'blur' }
        ]
      },
      editpassloading: false,
      formLabelWidth: '100px',
      userpass: {
        pass: '',
        editpass: '',
        neweditpass: ''
      },
    }
  },
  created() {
    this.getUserBindSnLicense(this.$route.query.id)
  },
  methods:{
    getUserBindSnLicense(userId){
      this.$axiosPost(this.$api.selectUserBindSnLicense,{userId:userId}).then(res=>{
         if (res.code == this.http.OK) {
           this.tableData = res.data
         }
      })
    },
    tableRowClassName({row, rowIndex}) {
      if (rowIndex % 2 == 0) {
        return 'success-row';
      }
      return '';
    },
    // 个人中心
    handleCommand (command) {
      switch (command) {
        case 'editpass':
          this.dialogFormVisible = true
          break
        case 'singOut':
          this.singOut()
          break
        default: break
      }
    },
    singOut () {
      window.sessionStorage.token = ''
      window.sessionStorage.clear()
      this.$router.push('/')
    },
    activationLog(row) {
      this.dialogActivationVisible = true;
      this.query.batchSn = row.batch_sn
      this.query.currentPage = 1
      this.getVirtualSnCreateLog()
    },
    getVirtualSnCreateLog() {
      this.loading2 = true
      this.$axiosPost(this.$api.selectVirtualSnCreateLog,this.query).then(res =>{
        this.loading2 = false
        if (res.code == this.http.OK) {
          this.gridData = res.data.list
          this.total = res.data.total
        }
      })
    },
    activationCurrentChange: function (val) {
      this.query.currentPage = val
      this.getVirtualSnCreateLog()
    },
    activationSizeChange: function (val){
      this.query.pageSize = val
      this.getVirtualSnCreateLog()
    },
    activatedSearch() {
      this.query.currentPage = 1
      this.getVirtualSnCreateLog()
    },
    activatedResetBtn() {
      this.query.virturlSn = null
      this.query.currentPage = 1
      this.query.createTime = null
      this.getVirtualSnCreateLog()
    },
    exportSnCreateLog(row) {
      this.$notify({title: '提示', message: '数据导出中', duration: 0,type: 'success'});
      this.$axiosPost(this.$api.exportVirtualSnCreateLog,{batchSn:row.batch_sn}).then(res =>{
        if (res.code == this.http.OK) {
          const dataSource = res.data;
          const fileName =row.batch_name+"授权记录.xlsx"
          exportFile({fileName,columns,dataSource})
          this.$notify.closeAll();
        }else {
          this.$notify.error({ message: res.msg })
        }
      })
    },
    exportSnUserCreateLog(row) {
      this.$notify({title: '提示', message: '数据导出中', duration: 0,type: 'success'});
      this.$axiosPost(this.$api.exportVirtualSnCreateLog,{batchSn:row.batch_sn,projectId: row.project_id}).then(res =>{
        if (res.code == this.http.OK) {
          const dataSource = res.data;
          const fileName =row.batch_name+"设备关联用户.xlsx"
          exportFile({fileName,columns:columns2,dataSource})
          this.$notify.closeAll();
        }else {
          this.$notify.error({ message: res.msg })
        }
      })
    },
    // 取消修改密码弹出框
    cancelUserPass () {
      this.$refs.userpass.resetFields()
      this.dialogFormVisible = false
    },
    // 修改密码
    userEditpass (formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.editpassloading = true
          this.$axiosPost(this.$api.editpassapi, {
            pass: md5(this.userpass.pass),
            editpass: md5(this.userpass.editpass)
          }).then(res => {
            if (res.code === this.http.OK) {
              this.$notify.success({ message: '修改密码成功' })
              this.$refs.userpass.resetFields()
              this.editpassloading = false
              this.dialogFormVisible = false
              this.$router.push({path: '/'})
            } else {
              this.editpassloading = false
              this.$notify.error({ message: res.msg })
            }
          })
        }
      })
    },

  }
}
</script>

<style lang="less">

.el-home2 {
  width: 100vw;
  height: 100vh;

.el-top-header{
  position: relative;
  background-color: #fff;
  height: 80px !important;
  width: 100vw;
  padding: 0px !important;
  display: flex;
  box-shadow: rgba(0, 0, 0, 0.14) 0px 3px 4px 0px;
  z-index: 99;
  min-width: 1120px;

.header-logoName{
  display: flex;
  margin-left: 30px;
  min-width: 390px;
  cursor: pointer;
.logo{
  margin-top: 10px;
  width: 60px;
  height: 60px;
}
.header-loginTitle{
  margin-left: 20px;
  font-weight: bold;
  color: #000;
  text-align: center;
  overflow: hidden;
  min-width: 300px;
.header-login_P1_Title{
  line-height: 45px;
  font-size: 24px;
  letter-spacing: 1px;
}
.header-login_p2_Title{
  line-height: 30px;
  font-size: 12px;
}
}
}
.header-systemTypeBtnList{
  display: flex;
  margin-left: 80px;
  color: #000000;
  overflow: hidden;
div,li{
  min-width: 100px;
  line-height: 80px;
  transition: all 300ms ease;
  cursor: pointer;
  text-align: center;
  font-family: SourceHanSansSC;
  font-weight: 700;
  font-size: 20px;
  font-style: normal;
  letter-spacing: 0px;
  text-decoration: none;
}
div:hover{
  color: rgba(117, 116, 249, 1);
}
.btnActive {
  color: rgba(117, 116, 249, 1);
}
.el-menu--horizontal>.el-menu-item,.el-menu--horizontal>.el-submenu .el-submenu__title{
  height: 80px !important;
}
}
.header-system{
  display: inline-block;
  position: absolute;
  height: 80px;
  right: 20px;
.userinfo{
  text-align: right;
  display: flex;
.userinfo-txt{
  height: 80px;
  line-height: 80px;
  margin-right: 15px;
}
.userinfo-icon{
  width: 60px;
  text-align: center;
  line-height: 95px;
i{
  font-size: 42px;
}
}
.el-dropdown{
  height: auto !important;
}
.userinfo-inner{
  cursor: pointer;
  line-height: 90px;
}
}
}
}

  .el-table .warning-row {
    background: oldlace;
  }
  .el-table .success-row {
    background: #f0f9eb;
  }
}
</style>



// WEBPACK FOOTER //
// src/views/account/virtualSnListView.vue